import {
  InternalLinkWrapper,
  InternalLinkStyle
} from './InternalLinkModule.styles';

type OwnProps = {
  isVisible: boolean;
  title: string;
  link: string;
};

export default function InternalLink({ isVisible, title, link }: OwnProps) {
  return (
    <InternalLinkWrapper key={link} isVisible={isVisible}>
      <InternalLinkStyle
        href={`/cars${link}`}
        data-analytics-id="Internal Link"
      >
        {title}
      </InternalLinkStyle>
    </InternalLinkWrapper>
  );
}
